<template>
    <div class="land_addon">
        
        <standart title="Продаж земельної ділянки співробітнику ІМК" key="land_addon"
            v-bind:is_active_result=false
            v-bind:is_active_problem=false>
        </standart>
        
        <b-container fluid v-if="addon">
            <h1 class="title text-center pt-5 pb-5 mt-5">
                Інформація про лот
            </h1>
            
            <div class="main_info">
                <b-row class="doc_title" :key="field.id" v-for="field in this.pull_pai_fields">
                    <b-col sm="3">
                        <label :for="field.type + field.id">{{field.name}} </label>
                    </b-col>
                    <b-col sm="4">
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            v-if="field.type === 'string_input'"
                            :state="is_valid_field(field)"
                            v-model="field.value"
                            :id="field.type + field.id"
                            size="sm" >
                        </b-form-input>
                        
                        <b-form-radio-group
                            id="btn-radios-1"
                            v-if="field.type === 'yes_no'"
                            v-model="field.value"
                            button-variant="outline-primary"
                            :options=addon_options
                            name="radios-btn-default"
                            buttons
                        ></b-form-radio-group>
                    
                    </b-col>
                </b-row>
                
                
                <b-row class="mt-3 mb-3 doc_title" v-if="cur_choice_val === 'hand' ">
                    <b-col sm="3">
                        <label>Погоджувач</label>
                    </b-col>
                    <b-col sm="4">
                        <div class="add user cursor-pointer" @click="add_user('adjust')" v-if="!this.obj_to_null(this.adjust_user)">
                            <i title="" class="fa add_user fa-plus-square" data-type="delegate_users"></i>
                            <span>Оберіть користувача</span>
                        </div>
                        
                        <user_block v-else
                                    :key="this.adjust_user.value.id"
                                    v-bind:can_del=true
                                    del_triger="remove_adjust"
                                    v-bind:user="this.adjust_user.value">
                        </user_block>
                    
                    </b-col>
                </b-row>
                
                <b-row class="mt-3 mb-3 doc_title" v-if="cur_choice_val === 'hand'">
                    <b-col sm="3">
                        <label>Виконавець</label>
                    </b-col>
                    <b-col sm="4">
                        <div class="add user cursor-pointer" @click="add_user('worker')"  v-if="!this.obj_to_null(this.recipient_user)">
                            <i title="" class="fa add_user fa-plus-square" data-type="delegate_users"></i>
                            <span>Оберіть користувача</span>
                        </div>
                        <user_block v-else
                                    :key="this.recipient_user.value.id"
                                    v-bind:can_del=true
                                    del_triger="remove_recipient"
                                    v-bind:user="this.recipient_user.value">
                        </user_block>
                    
                    </b-col>
                </b-row>
            
            </div>
            
            <b-tabs content-class="mt-3">
                <b-tab
                    active-nav-item-class="font-weight-bold text-uppercase text-danger"
                    v-for="(tab,index) in this.pull_pai_items" @click="set_active(tab)" :key="index" :active="tab.is_active">
                    <template slot="title">
                        <div class='icon-stack fs-xxl'>
                            <i class="base base-7 icon-stack-2x opacity-100 color-primary-500"></i>
                            <i class="fal fa-globe-americas icon-stack-1x opacity-100 color-white"></i>
                        </div>
                        
                        {{get_tab_title(index)}}
                        
                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                        
                        <div class='icon-stack fs-xxl cursor-pointer ml-3' v-if="index > 0" v-on:click.stop.prevent="remove_tab(index)">
                            <i class="fal fa-trash-alt icon-stack-1x opacity-100 color-danger-500"></i>
                        </div>
                    </template>
                    
                    <land_pai
                        :owner_field="owner_field"
                        :key="'pai_' + index"
                        :pai_item="tab">
                    </land_pai>
                </b-tab>
                
                <template #tabs-end>
                    <b-nav-item role="presentation" @click.prevent="add_pull_pai" href="#">
                        Додати <b>+</b>
                    </b-nav-item>
                </template>
            </b-tabs>
        </b-container>
    </div>
</template>


<script>
import land_pai from "./tabs/land_pai.vue";
import standart from "../standart.vue";
import user_block from "../../../../../../shared/user/user_block/user_block.vue";

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});

export default {
    name: "land",
    
    components : {
        standart,
        land_pai,
        user_block
    },
    
    created() {
        EventBus.$on("set_memorandum_data",this.remove_dir);
        EventBus.$on('selected_users', this.set_user);
        EventBus.$on('remove_adjust',this.remove_adjust)
        EventBus.$on('remove_recipient',this.remove_recipient)
    },
    
    
    beforeDestroy() {
        console.log('kill land');
        
        if (myapp_config.debugState)
            console.log("%c✔ kill right_side", "color: #ffc241");
        
        EventBus.$off("set_memorandum_data",this.remove_dir);
        EventBus.$off("selected_users",this.set_user);
    },
    
    
    methods : {
        
        remove_recipient (e) {
            this.pull_pai.fields = this.pull_pai_fields.filter(item => {
                return item.field_type !== 'land_worker';
            })
        },
        
        remove_adjust(e) {
            console.log('remove_adjust');
            this.pull_pai.fields = this.pull_pai_fields.filter(item => {
                return item.field_type !== 'land_adjust';
            })
        },
        
        set_user(event) {
            console.log(event);
            let title = "Погоджувач";
            
            if(event.uniq !== 'land_adjust') {
                title = "Виконавець";
            }
            
            this.pull_pai_fields.push({
                "field_group" : "pull_pai",
                'title' : title,
                'field_type' : event.uniq,
                "id" : 0,
                "value" : event.users[0],
            })
            EventBus.$emit('close_u_filter');
        },
        
        add_user(type) {
            EventBus.$emit('load_users_filter', {
                    uniq      : 'land_' + type,
                    active: [],
                }
            );
        },
        
        add_pull_pai() {
            let pai_push = {
                "is_active" : false,
                "is_load" : false,
                "fields" : JSON.parse(JSON.stringify(this.addon_fields))
            }
            console.log("%c|___Add new PAI", "color: #ffc241",pai_push);
            this.pull_pai_items.push(pai_push);
        },
        
        remove_tab(idx) {
            this.pull_pai_items.splice(idx,1);
        },
        
        set_active(tab) {
            tab.is_active = true;
            this.pull_pai_items.map(itm => {
                itm.is_active = false;
            })
        },
        
        get_tab_title(idx) {
            let cur_idx = idx + 1;
            return "Пай " + cur_idx;
        },
        
        is_valid_field(field) {
            if (parseInt(field.required) === 1) {
                try {
                    if (field.type === 'string_input') {
                        return field.value.toString().length > 1;
                    }
                } catch (e) {
                
                }
                
                return false;
            }
            return true;
        },
        
      
        
    },
    
    computed : {
        ...mapFields([
            'active_memorandum'
        ]),
        
        
        addon_options() {
            return [
                { text: 'Так', value: 'yes' },
             //   { text: 'Ні', value: 'no' }	,
                { text: 'Вручну', value: 'hand' }
            ];
        },
        
        addon() {
            return this.active_memorandum.addon_data;
        },
        
        addon_fields() {
            if(this.addon.hasOwnProperty("fields")) {
                return this.addon.fields;
            }
            
            return [];
        },
        
        pull_pai() {
            if(this.addon.hasOwnProperty('pull_pai')) {
                return this.addon.pull_pai;
            }
            
            return  {
                "items" : [],
                "fields" : [],
            }
        },
        
        pull_pai_items () {
            return this.pull_pai.items;
        },
        
        pull_pai_fields () {
            return this.pull_pai.fields;
        },
        
        adjust_filed() {
            let owner = null;
            this.pull_pai_fields.map(item => {
                if(item.field_type === 'adjust') {
                    owner = item;
                }
            })
            
            return owner;
        },
        
        owner_field () {
            let owner = {
                "filed_type" : "kontragent",
                "value" : "",
            };
            this.pull_pai_fields.map(item => {
                if(item.field_type === 'kontragent') {
                    owner = item;
                }
            })
            
            return owner;
        },
        
        
        cur_choice_val() {
            if(this.current_choice_radio_field != null) {
                return this.current_choice_radio_field.value;
            }
            return "yes";
        },
        
        current_choice_radio_field() {
            let active = null;
            this.pull_pai_fields.map(item => {
                console.log(item);
                if(item.field_type == "is_random") {
                    active = item;
                }
            })
            
            return active;
        },
        
        recipient_user() {
            if(this.cur_choice_val === 'hand') {
                let list = this.pull_pai_fields.filter(item => {
                    return item.field_type === 'land_worker';
                });
                
                if(list) {
                    return list[0];
                }
            }
            return null;
        },
        
        
        adjust_user() {
            if(this.cur_choice_val === 'hand') {
                let list = this.pull_pai_fields.filter(item => {
                    return item.field_type === 'land_adjust';
                });
                
                if(list) {
                    return list[0];
                }
            }
            return null;
        },
        
        return_data : function () {
            return this.pull_pai;
        },
        
    }
}
</script>

<style scoped>

</style>